module.exports = __webpack_public_path__ + "static/img/平面食品拍摄.a39d655.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10010/平面食品拍摄.png
// module id = L1y3
// module chunks = 1